module.exports = __webpack_public_path__ + "static/mural-5-fbd31ce63c9f220ee0a1a5b1aff79612.jpg";